import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const CtaSection = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.15 });

  return (
    <section className="py-24 bg-navy-800 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="/assets/readdy/ctaBGnexus-1920x600-landscape-789d66f6.jpg"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/80 to-navy-800/60" />
      </div>

      <div
        ref={ref}
        className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s cubic-bezier(0.22,1,0.36,1), transform 0.8s cubic-bezier(0.22,1,0.36,1)',
        }}
      >
        <h2
          className="text-3xl sm:text-4xl font-bold text-white mb-5 tracking-tight leading-tight"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
            transitionDelay: '100ms',
          }}
        >
          準備好踏上你的<br />
          全球 AI 職涯之路了嗎？
        </h2>

        <p
          className="text-slate-300 text-base leading-relaxed mb-10 max-w-2xl mx-auto"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
            transitionDelay: '180ms',
          }}
        >
          從履歷精修到 1 對 1 面試衝刺，NexusGo 頂尖外商導師團隊為你提供
          全方位的職涯提升服務，助你以最短路徑拿下理想 Offer。
        </p>

        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(16px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
            transitionDelay: '260ms',
          }}
        >
          <Link
            to="/mentors"
            className="w-full sm:w-auto px-8 py-3.5 bg-violet-600 text-white text-sm font-semibold rounded-lg cursor-pointer whitespace-nowrap hover:bg-violet-700 transition-all text-center"
          >
            <i className="ri-user-star-line mr-2" />
            立即預約導師
          </Link>
          <Link
            to="/courses"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/10 text-white text-sm font-semibold rounded-lg border border-white/20 cursor-pointer whitespace-nowrap hover:bg-white/20 transition-all text-center"
          >
            <i className="ri-book-open-line mr-2" />
            瀏覽精選課程
          </Link>
        </div>

        <p
          className="text-slate-500 text-xs mt-6"
          style={{
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 0.6s ease',
            transitionDelay: '360ms',
          }}
        >
          導師定價透明 · 專屬 1V1 諮詢 · 24 小時內確認
        </p>
      </div>
    </section>
  );
};

export default CtaSection;
